import { SwedenHolidays } from '@constants/holidays/europe/swedenHolidays';
import { FinlandHolidays } from '@constants/holidays/europe/finlandHolidays';
import { NorwayHolidays } from '@constants/holidays/europe/norwayHolidays';
import { DenmarkHolidays } from '@constants/holidays/europe/denmarkHolidays';
import { SpainHolidays } from '@constants/holidays/europe/spainHolidays';
import { SwitzerlandHolidays } from '@constants/holidays/europe/switzerlandHolidays';
import { GermanyHolidays } from '@constants/holidays/europe/germanyHolidays';
import { UsaHolidays } from '@constants/holidays/usa/usaHolidays';
import { CanadaHolidays } from '@constants/holidays/usa/canadaHolidays';
import { AustraliaHolidays } from '@constants/holidays/usa/australiaHolidays';
import { FranceHolidays } from '@constants/holidays/europe/franceHolidays';
import { NetherlandsHolidays} from '@constants/holidays/europe/netherlandsHolidays';
import { BelgiumHolidays } from '@constants/holidays/europe/belgiumHolidays';
import { UKHolidays } from '@constants/holidays/europe/ukHolidays';
import { IHoliday } from '@constants/holidays/holidayTypes';

interface IHolidaysMap {
  [key: string]: { [date: string]: IHoliday };
}

interface ICountryHolidaysMap {
  SE: { [date: string]: IHoliday };
  FI: { [date: string]: IHoliday };
  NO: { [date: string]: IHoliday };
  DK: { [date: string]: IHoliday };
  ES: { [date: string]: IHoliday };
  CH: { [date: string]: IHoliday };
  DE: { [date: string]: IHoliday };
  FR: { [date: string]: IHoliday };
  BE: { [date: string]: IHoliday };
  NL: { [date: string]: IHoliday };
  GB: { [date: string]: IHoliday };
  US: { [date: string]: IHoliday };
  CA: { [date: string]: IHoliday };
  AU: { [date: string]: IHoliday };
}

const holidayMap: ICountryHolidaysMap & IHolidaysMap = {
  SE: SwedenHolidays,
  FI: FinlandHolidays,
  NO: NorwayHolidays,
  DK: DenmarkHolidays,
  ES: SpainHolidays,
  CH: SwitzerlandHolidays,
  DE: GermanyHolidays,
  FR: FranceHolidays,
  BE: BelgiumHolidays,
  NL: NetherlandsHolidays,
  GB: UKHolidays,
  US: UsaHolidays,
  CA: CanadaHolidays,
  AU: AustraliaHolidays,
};

export const holidays: ICountryHolidaysMap & {
  getHolidays: (country?: string) => { [date: string]: IHoliday };
} = {
  ...holidayMap,

   getHolidays(country?: string): { [date: string]: IHoliday } {
    if (!country) {
      return {};
    }
    return holidayMap[country.toUpperCase()] || {};
  }
};



// WEBPACK FOOTER //
// ./src/components/calendar2/holidays/holidays.ts